import { render, staticRenderFns } from "./experienceClass.vue?vue&type=template&id=2ab4822d&scoped=true"
import script from "./experienceClass.vue?vue&type=script&lang=js"
export * from "./experienceClass.vue?vue&type=script&lang=js"
import style0 from "./experienceClass.vue?vue&type=style&index=0&id=2ab4822d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab4822d",
  null
  
)

export default component.exports